import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { InstituteService } from 'src/app/Services/institute.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-institute-details',
  templateUrl: './institute-details.component.html',
  styleUrls: ['./institute-details.component.scss']
})
export class InstituteDetailsComponent implements OnInit {
  displayedColumns: string[] = ['serial', 'instituteDetails', 'program', 'activities'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();

  searchText: any;
  state:any;
  district:any;
  instType:any;
  womenInst:any;
  nba:any;
  pid: any;
  email: any;
  instTypes: any = [];
  states: any = [
    {'id':9,'state':'Delhi'},
  ];
  districts: any = [];
  filterForm:FormGroup;
  page:any;

  showMatSpinner = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private instituteService: InstituteService,
    private toastr: ToastrService,
    private fb: FormBuilder) { 
  }

  ngOnInit(): void {
    this.createForm();
    this.filterForm.controls.state.setValue([this.states[0]['id']])
    this.getDefaultStateDistrict(this.states[0]['id'])
    this.getAllInstitutes();
    this.getStates();
    this.getAllInstTypes();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  createForm(){
    this.filterForm = this.fb.group({
      instType: [null],
      womenInst: [null],
      nba: [null],
      state: [null, Validators.required],
      district: [null],
      pid: [null],
      email: [null]
    });
  }

  getDefaultStateDistrict(data){
    if(data){
      this.instituteService.getDistrictByMultiStates(data).subscribe(data=>this.setDistricts(data));
    }else{
      this.districts = [];
      this.filterForm.controls.district.setValue(null);
    }
  }

  // getInstituteDetails() {
  //   this.instituteService.getParakhInstituteDetails().subscribe(
  //     data => this.setInstituteDetails(data)
  //   )
  // }

  getAllInstitutes(){
    if (this.filterForm.valid) {
      this.showMatSpinner = true;
      var formValues = this.filterForm.value;
      if(this.filterForm.controls.email.value){

        formValues['email'] = btoa(this.filterForm.controls.email.value);
        // console.log(formValues);
        
      }
      
      this.instituteService.getParakhInstituteDetails(this.filterForm.value)
        .subscribe(data =>this.setInstituteDetails(data));
    } else {
      this.showMatSpinner = false;
      this.toastr.error('Kindly select any state');
    }
  }

  setInstituteDetails(data) {
    if(data['type'] == 'Success') {
    this.showMatSpinner = false;

      this.dataSource = new MatTableDataSource(data['institutes']);
      this.dataSource.filterPredicate = this.filterObject;
      this.dataSource.paginator =this.paginator;
      // this.dataSource.sort = this.sort;
      if(this.searchText){
        this.applyFilter();
      }
    }
    else {
      this.toastr.error(data['message']);
    }
  }

  getStates(){
    this.instituteService.getState().subscribe(data=>this.states = data['states']);
  }

  getDistrictByMultiStates(event){
    if(event.value.length){
      this.instituteService.getDistrictByMultiStates(event.value).subscribe(data=>this.setDistricts(data));
    }else{
      this.districts = [];
      this.filterForm.controls.district.setValue(null);
    }
  }

  setDistricts(data){
    if(data['type'] == 'Success'){
      this.districts = data['districts'];
    }else{
      this.toastr.error(data['message']);
    }
  }

  getAllInstTypes(){
    this.instituteService.getInstTypes().subscribe(data=> this.instTypes = data['types']);
  }

  filterObject(obj, filter):boolean{
    const matchFilter = [];
    const filterArray = filter.split(' ');
    const columns = (<any>Object).values([
      String(obj['PERMANENT_ID']),
      String(obj['CURRENT_INSTITUTE_NAME']),
      String(obj['CURRENT_INSTITUTE_ADDRESS']),
      String(obj['INSTI_STATE']),
      String(obj['INSTITUTE_DISTRICT']),
      String(obj['PROGRAMME']),
      ]);

    filterArray.forEach(filter => {
      const customFilter = [];
      columns.forEach(column => customFilter.push(column.toLowerCase().includes(filter)));
      matchFilter.push(customFilter.some(Boolean)); // OR
    });
    return matchFilter.every(Boolean);
  }

  applyFilter() {
    const filterValue = this.searchText;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
  }
}
